import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dropdown-arrows",
  "use": "icon-dropdown-arrows-usage",
  "viewBox": "0 0 8 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 21\" id=\"icon-dropdown-arrows\">\n    <path fill=\"currentColor\" d=\"M7.98 16.156l-3.898 4.587-3.898-4.587zM.184 4.845L4.082.257 7.98 4.844H.184z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol